// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import "./index.css";

import { SnackbarProvider } from "./contexts/SnackbarContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AuthProvider } from "./contexts/AuthContext";
import { PlanProvider } from "./contexts/PlanContext";
import { PlanModalProvider } from "./contexts/PlanModalContext";
import { BrowserRouter } from "react-router-dom";

// 👇 importe o provider ADM
import { AdminAuthProvider } from "./contexts/AdminAuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <SnackbarProvider>
    <ThemeProvider>
      <AuthProvider>
        {/* 👇 Provider de autenticação exclusiva do ADM */}
        <AdminAuthProvider>
          <PlanProvider>
            <PlanModalProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </PlanModalProvider>
          </PlanProvider>
        </AdminAuthProvider>
      </AuthProvider>
    </ThemeProvider>
  </SnackbarProvider>
);